import { useRouterState } from "@tanstack/react-router";
import type { ReactNode } from "react";

import { TrackingScope } from "@/components/TrackingScope";
import { buildAnalyticsPageContext } from "@/lib/analytics";

const TRACKING_SURFACE_BY_PAGE_TYPE: Record<string, string> = {
  catalog_entity: "catalog_detail",
  editorial_feature: "feature_page",
  marketplace_listing: "listing_detail",
  offer_collection: "offers_index",
  public_profile: "profile_store",
  search_results: "search",
};

function trackingEntityType(entityType: string) {
  switch (entityType) {
    case "artist":
    case "company":
    case "offer":
    case "release":
    case "work":
      return entityType;
    default:
      return undefined;
  }
}

export function RouteTrackingScope({ children }: { children: ReactNode }) {
  const pathname = useRouterState({ select: (state) => state.location.pathname });
  const page = buildAnalyticsPageContext(pathname);
  const entityType = trackingEntityType(page.entity_type);
  const catalogSurface =
    page.page_type === "catalog_entity" && entityType ? `${entityType}_detail` : undefined;
  const surface = catalogSurface ?? TRACKING_SURFACE_BY_PAGE_TYPE[page.page_type] ?? page.page_type;

  return (
    <TrackingScope surface={surface} entityType={entityType}>
      {children}
    </TrackingScope>
  );
}
